import moment from 'moment';
import {
  cloneDeep
} from 'lodash';

export default class InscriptionsCalcs {

  userData = null;
  expoData = null;
  dogList = [];
  inscripciones = [];
  contador = {
    inicio: 0,
    fin: 0
  };
  debug = false;
  tarifaActual = null;
  socio = 0;
  tarifaNormalizada = null;

  /* CONSTRUCTOR */
  constructor(_userData, _expoData, _inscripciones, _socio) {

    this.userData = _userData;
    this.expoData = _expoData;
    if (_inscripciones !== null) {
      this.inscripciones = _inscripciones;
    }
    this.tarifaActual = this._getTarifaActual(this.expoData);
    console.log(this.tarifaActual)
  }

  /* 
  ===============================================================
  #region DES/ASIGNACION DE PERROS A TARIFAS
  ===============================================================
  */

  /* LLAMADA PARA ASIGNAR UN PERRO A UNA TARIFA */
  async generarTarifa2(classId, dog, partner) {
    this.socio = partner;
    await this._calcularTarifa(classId, dog);
    await this._calcularImportes();
    await this._normalizarData();
    return this.inscripciones;
  }

  /* FUNCION PARA ELIMINAR UN PERRO DE UNA TARIFA EXISTENTE */

  eliminarPerroInscripciones(dog) {

    const promesa = new Promise((resolve, reject) => {
      let inscr = this.inscripciones;
      const dogId = parseInt(dog.id);
      // const dogGrupoPrecio = parseInt()
      console.log("el perro a eliminar", dog);
      //si comprobamos que no hay inscripciones... retornamos true
      if (inscr.length === 0) {
        return resolve(true);
      }

      //recorremos todas las inscripciones
      let cont = 0;
      for (let element of inscr) {

        let existe = element.dogs.map(x => x.id).includes(dogId);
        //si existe el perro en la tarifa iterada lo eliminamos y recalculamos
        if (existe) {

          //si solo hay un perrete en la tarifa la eliminamos por completo
          if (element.dogs.length === 1) {

            console.log("lo elimino porque solo hay uno -> dogId", dogId)
            inscr.splice(cont, 1);

          } else {

            //si hay más de uno debemos filtrar el perro a eliminar y recalcular los existentes
            let dog = element.dogs.filter((x) => {
              return x.id === dogId
            });
            console.log("el perro datos", dog)

            let listaFiltrada = element.dogs.filter((x) => {
              return (x.id !== dogId) && x.grupoPrecio === dog.grupoPrecio;
            });

            /*
            comprobamos si en la lista filtrada hay solo un perro, 
            y si lo hay pues aplicamos a la inscr la lista filtrada.
            ya que no tenemos que recalular nada
            */
            if (listaFiltrada.length === 0) {
              element.dogs = element.dogs.filter((x) => x.id !== dogId);
              console.log("filtramos el perro ya que en su grupo/tarifa solo estaba el y lo agregamos a la inscripcion")
              continue;

            } else {

              this._recalificarPerrosEnTarifa(listaFiltrada, element.precio)
                .then(res => {
                  console.log("retorno de la promesa", dog, res, existe, listaFiltrada, inscr)
                  element.dogs = res;
                });

            }


          }
        }
        console.log("contador", cont)
        //continuamos iterando hasta el final por si por un hechizo de nivel 57 se ha colado el perro en otra inscripcion             
        cont++;
      }
      return resolve(true);
    });
    //retornamos la promesa
    return promesa;
  }
  /* FUNCION PARA RECALIFICAR PERROS EN TARIFA AL ELIMINAR 1 */
  _recalificarPerrosEnTarifa(dogs, precios, grupoPrecio) {

    console.log("_recalificarPerrosEnTarifa", dogs, precios);

    const promesa = new Promise((resolve, reject) => {

      const contPrecio = precios.length;
      let c = 1;
      dogs.forEach((x) => {

        console.log("antes", x);
        const elPrecio = (c < contPrecio) ? precios[c - 1] : precios[contPrecio - 1];
        x.posicion = c;
        x.precio = {
          'price': elPrecio.price,
          'price_partner': elPrecio.price_partner
        };
        x.precioAplicado = (c < contPrecio) ? c : contPrecio;
        c++;
        console.log("despues", x);

      });

      return resolve(dogs);

    });

    return promesa;

  }

  /* FUNCION PARA CALCULAR UNA TARIFA EN BASE A LOS DATOS DEL ANIMAL */
  _calcularTarifa(classId, dog) {

    return new Promise((resolve, reject) => {
      let precios = this.tarifaActual;
      //console.log("calcular importe total", precios)
      let eligibleClase = null;
      let eligibleCountry = null;
      let eligibleBreed = null;
      let tarifaEligible = [];
      let contadorTarifasEligibles = 0;
      //recogemos las tarifas de la inscripción
      let expoRateTypes = precios.expo_rate_types;
      //iteramos y comprobamos las coincidencias
      for (let j = 0; j < expoRateTypes.length; j++) {
        let contadorFiltros = 0;
        const tarifa = expoRateTypes[j];
        //si coincide la raza
        if (tarifa.breeds_id !== null) {
          const breeds = tarifa.breeds_id.split(",").map(Number);
          if (breeds.includes(dog.breed_id)) {
            contadorFiltros++;
            eligibleBreed = true;
          } else {
            eligibleBreed = false;
          }
        }
        //si coincide la clase
        if (tarifa.classes_id !== null) {
          const clases = tarifa.classes_id.split(",").map(Number);
          if (clases.includes(classId)) {
            contadorFiltros++;
            eligibleClase = true;
          } else {
            eligibleClase = false;
          }
        }
        //si coincide el pais              
        if (tarifa.countries_id !== null) {
          this._debug(tarifa.id + " hay paises");
          const countries = tarifa.countries_id.split(",").map(Number);
          if (countries.includes(this.userData.nationality)) {
            contadorFiltros++;
            eligibleCountry = true;
          } else {
            eligibleCountry = false;
          }
        }

        //si hay alguna condicion es falso continuamos ya que no es eligible
        if (
          eligibleClase === false || eligibleBreed === false || eligibleCountry === false
        ) {
          this._debug("este rate no es eligible->" + tarifa.id);
          continue;
        } else {
          contadorTarifasEligibles++;
          //precio para los NO socios
          let miPrecio = tarifa.expo_prices.map(x => x.price);
          //precio de socios y no socios en un arrayObj
          let precioTotal = tarifa.expo_prices.map((x) => ({
            price: x.price,
            price_partner: x.price_partner
          }));
          this._debug("precioTotal->" + precioTotal);
          this._debug("tarifa eligible->" + tarifa.id + ", precios -> " + miPrecio);
          
          tarifaEligible.push({
            tarifaId: tarifa.id,
            importe: precioTotal,
            filtrosAplicados: contadorFiltros,
            posicion: 0,
            socio: this.socio,
            copropietarios: this._getDogCoOwners(dog.id),
            grupoPrecio: 0
          });
        }
      }
      if (contadorTarifasEligibles === 0) {
        alert("No existen tarifas para este perro");
        tarifaEligible = [];
        return resolve(false);
      }
      //calculamos la tarifa con el mayor numero de filtros
      const tarifaFinal = tarifaEligible.reduce((acc, tarifa) => {
        return (acc.filtrosAplicados < tarifa.filtrosAplicados) ? tarifa : acc;
      });
      console.log(tarifaFinal, dog)
      //actualizamos las inscripciones... desde una promesa      
      this._agregarPerroInscripciones(dog, tarifaFinal)
        .then(res => {
          //clonamos el obj para no modificar el res
          this.inscripciones = cloneDeep(res);
          return resolve(true);
        });
    });
  }
  /* FUNCION PARA ACTUALIZAR LAS TARIFAS DE LOS PERRETES INSCRITOS */
  _agregarPerroInscripciones(dog, tarifaFinal) {

    return new Promise((resolve, reject) => {
      let inscr = cloneDeep(this.inscripciones);
      // si no existen inscripciones lo agregamos y finalizamos
      if (inscr.length === 0) {
        inscr.push({
          tarifaId: tarifaFinal.tarifaId,
          dogs: [{
            id: dog.id,
            clase: dog.class_selected,
            precio: 0,
            filtrosAplicados: tarifaFinal.filtrosAplicados,
            descuentos: this._generarListaDescuentos(dog),
            socio: this.socio,
            copropietarios: this._getDogCoOwners(dog.id),
            grupoPrecio: 0
          }],
          precio: tarifaFinal.importe,

        });
        return resolve(inscr);
      }

      //al haber ya inscripciones hay que comprobarlas

      //comprobamos que no existe esa tarifa en el array
      const existeInscripcion = inscr.filter(
        x => x.tarifaId === tarifaFinal.tarifaId
      );
      //si no existe lo agregamos al obj
      if (existeInscripcion.length === 0) {
        inscr.push({
          tarifaId: tarifaFinal.tarifaId,
          dogs: [{
            id: dog.id,
            clase: dog.class_selected,
            precio: 0,
            filtrosAplicados: tarifaFinal.filtrosAplicados,
            descuentos: this._generarListaDescuentos(dog),
            socio: this.socio,
            copropietarios: this._getDogCoOwners(dog.id),
            grupoPrecio: 0
          }],
          precio: tarifaFinal.importe
        });
        return resolve(inscr);
      }

      //SI EXISTE YA UNA TARIFA... 
      //recorremos el array ya que existe en las inscripciones
      for (let i = 0; i < inscr.length; i++) {
        const element = inscr[i];
        //comprobamos si existe el perroid en la inscripcion de la iteracion actual para sacarlo
        element.dogs = element.dogs.filter(x => {
          return x !== dog.id;
        });
        //finalmente lo agregamos donde corresponde
        if (element.tarifaId === tarifaFinal.tarifaId) {
          element.dogs.push({
            id: dog.id,
            clase: dog.class_selected,
            precio: 0,
            filtrosAplicados: tarifaFinal.filtrosAplicados,
            descuentos: this._generarListaDescuentos(dog),
            socio: this.socio,
            copropietarios: this._getDogCoOwners(dog.id),
            grupoPrecio: 0
          });
          break;
        }
      }
      return resolve(inscr);
    })
  }
  /* FUNCION PARA CALCULAR EL IMPORTE Y AGREGARLO A INSCRIPCIONES */
  _calcularImportes() {

    return new Promise((resolve, reject) => {

      let inscr = this.inscripciones;
      //si no hay inscripciones la devolvemos tal cual
      if (inscr.length === 0) {
        return resolve(inscr);
      }
      //recorremos todas las inscripciones existentes dentro de la tarifa
      for (let i = 0; i < inscr.length; i++) {
        let element = inscr[i];

        //recorremos todos los perros de esa tarifa
        for (let j = 0; j < element.dogs.length; j++) {
          let dog = element.dogs[j];
          let maxPrecios = element.precio.length;
          let hayCopropietarios = dog.copropietarios.length > 0 ? 1 : 0;

          //comprobamos si el perro a tarificar tiene copropietarios o no
          if (hayCopropietarios === 1) {

            const allDogs = element.dogs.slice(0, j).filter(x => {
              if ((x.id !== dog.id) && (x.hayCopropietarios === 1)) {
                return x;
              }
            });
            //si es primero            
            if (allDogs.length === 0) {
              dog.precio = element.precio[0];
              dog.posicion = 1;
              dog.precioAplicado = 1;
              dog.hayCopropietarios = 1;
              dog.grupoPrecio = 10;
              continue;
            }
            //si hay mas de uno
            let coincidencias = this._comprobarOtrosDogsCopropietarios(allDogs, dog);
            let tmpCoincidencias = coincidencias.coincidencias;
            const numGrupos = allDogs.reduce((acc, current) => {
              if (!acc.includes(current.grupoPrecio)) {
                acc.push(current.grupoPrecio);
              }
              return acc;
            }, []);

            // console.log(allDogs, coincidencias, dog.id, j, numGrupos);

            //si no hay coindicidencias es un primero
            if (tmpCoincidencias == 0) {
              dog.precio = element.precio[0];
              dog.posicion = 1;
              dog.precioAplicado = 1;
              dog.hayCopropietarios = 1;
              dog.grupoPrecio = 10 + numGrupos.length;
              continue;
            } else if (tmpCoincidencias < maxPrecios) {
              //manejamos aqui el ajuste del precio dependiendo del copropietario
              dog.precio = element.precio[tmpCoincidencias];
              dog.posicion = tmpCoincidencias + 1;
              dog.precioAplicado = tmpCoincidencias + 1;
            } else {
              dog.precio = element.precio[maxPrecios - 1];
              dog.posicion = tmpCoincidencias + 1;
              dog.precioAplicado = maxPrecios;
            }
            dog.hayCopropietarios = 1;
            dog.grupoPrecio = coincidencias.grupoPrecio;
            continue;

          } else {
            //ZONA PARA PERROS SIN COPROPOPIETARIOS
            //como no hay copropietarios se le asigna el grupo 1 siempre           
            //comprobamos cuantas inscripciones sin coprop hay
            const contSinCop = element.dogs.slice(0, j).filter(x => {
              if ((x.id !== dog.id) && (x.hayCopropietarios === 0)) {
                return x;
              }
            });
            const contador = contSinCop.length;
            let precio = (contador < element.precio.length) ? element.precio[contador] : element.precio[element.precio.length-1];           
            dog.precio = {'price': precio.price , 'price_partner' : precio.price_partner };
            dog.posicion = contador + 1;
            dog.precioAplicado = (contador < element.precio.length) ? contador + 1 : element.precio.length;
            dog.hayCopropietarios = 0;
            dog.grupoPrecio = 1;        

          }
        }
      }
      return resolve(inscr);
    });
  }
  /* Comprobamos si al tener copropietarios coincide con otro */
  _comprobarOtrosDogsCopropietarios(allDogs, dog) {
    if (allDogs.length === 0)
      return 1;

    let coincidencias = 0;
    const numCoEnPerro = dog.copropietarios.length;
    let grupo = 0;

    for (let i = 0; i < allDogs.length; i++) {
      const element = allDogs[i];
      const numCo = element.copropietarios.length;
      //si el perro actual no tiene copropietarios o no coinciden el numero de coprop continuamos
      if (numCo == 0 || numCo !== numCoEnPerro) {
        continue;
      }
      //recorremos los copropietarios para compararlos con el perro de turno de la tarifa
      let tmpCoincidentes = 0;
      dog.copropietarios.forEach(e => {
        const cpName = e.name.trim().toUpperCase();
        const cpLastname = e.lastname.trim().toUpperCase();
        tmpCoincidentes += element.copropietarios.filter(x => {
          if (x.name.trim().toUpperCase() === cpName && x.lastname.trim().toUpperCase() === cpLastname) {
            return x;
          }
        }).length;
      });
      if (tmpCoincidentes === numCoEnPerro) {
        coincidencias += 1;
        grupo = element.grupoPrecio;
      }

    }
    return {
      coincidencias: coincidencias,
      grupoPrecio: grupo
    };
  }
  /* FUNCION PARA VER SI EXISTE DESCUENTO DE CUALQUIER TIPO Y AGREGARLO A LA TARIFA */
  _generarListaDescuentos(dog) {
    const descuentos = this.expoData.expo_discounts;
    //const descuentos = this.expoData.expo_discounts;
    // console.log("descuentos", descuentos)
    let descuentoBreed = null;
    let descuentoClass = null;
    let descuentoCountry = null;
    let tmp = [];
    if (descuentos.length === 0) {
      return tmp;
    }
    this._debug("descuentos->" + descuentos.length)
    //iteramos por los descuentos
    for (let i = 0; i < descuentos.length; i++) {
      const descuento = descuentos[i];
      //Check Descuento razas
      if (descuento.breeds_id !== null) {
        let existe = descuento.breeds_id.split(',').map(x => parseInt(x)).includes(dog.breed_id);
        if (existe === true) {
          descuentoBreed = true;
        } else {
          //si es falso, este descuento no se puede aplicar           
          continue;
        }
      } else {
        //marco para comprobar que no se debe evaluar
        descuentoBreed = false;
      }
      //Check descuento clase
      if (descuento.classes_id !== null) {
        let existe = descuento.classes_id.split(',').map(x => parseInt(x)).includes(dog.class_selected);
        if (existe === true) {
          descuentoClass = true;
        } else {
          //si es falso, este descuento no se puede aplicar          
          continue;
        }
      } else {
        //marco para comprobar que no se debe evaluar
        descuentoClass = false;
      }
      //Check descuento Country
      if (descuento.countries_id !== null) {
        let existe = descuento.countries_id.split(',').map(x => parseInt(x)).includes(dog.class_selected);
        if (existe === true) {
          descuentoCountry = true;
        } else {
          //si es falso, esta tarifa no se puede aplicar por pais           
          continue;
        }
      } else {
        //marco para comprobar que no se debe evaluar
        descuentoCountry = false;
      }

      //SI LLEGAMOS AQUI COMPROBAMOS SI HAY DESCUENTO Y LO APLICAMOS
      if (descuentoClass === true || descuentoBreed === true || descuentoCountry === true) {
        tmp.push({
          id: descuento.id,
          tipo: descuento.price_type_discount_id, // 1 importe , 2 descuento
          descuento: descuento.discount
        })
      }
    }
    //FINALMENTE SI TENEMOS DESCUENTOS LO RETORNAMOS
    if (tmp.length > 0) {
      return tmp
    } else {
      return [];
    }

  }
  /* funcion para recoger los datos de los copropietarios */
  _getDogCoOwners(dogId) {
    return this.userData.dogs.filter(x => x.id == dogId)[0].cowners;
  }
  /* 
  ===============================================================
  #endregion DES/ASIGNACION DE PERROS A TARIFAS
  ===============================================================
  */

  /* 
   ===============================================================
   #region GETTERS
   ===============================================================
  */
  /* DEVUELVE UNA LISTA DE LAS INSCRIPCIONES */
  getInscripciones() {
    return this.inscripciones;
  }
  /* FUNCION PARA RETORNAR LOS DATOS DE LAS INSCRIPCIONES NORMALIZADOS */
  getInscripcionesNormalizadas() {
    return this.tarifaNormalizada;
  }

  /* 
 ===============================================================
 #endregion GETTERS
 ===============================================================
 */

  /* 
  #region Tarifa Eligibles para los perros de los usuarios
  =================================================================
  REGION PARA CREAR LAS TARIFAS ELIGIBLES DE CADA PERRO DEL USUARIO
  =================================================================  
  */

  /* FUNCION PRINCIPAL PARA GENERAR LA LISTA DE PERROS Y CLASES A ELEGIR */
  generarListaDePerrosEligibles() {
    //generamos un array con la lista de los perros 
    this.contador.inicio = Date.now();
    // this.dogList = this._currentLocalDogsUser();
    this.dogList = this._currentLocalDogsUserTarifaActual();
    //console.log(this.dogList);
    this._debug("tiempo empleado GenerarLista->" + this.getTiempo() + "ms")
    return this.dogList;
  }
  /* FUNCION PARA COMPROBAR LA TARIFA ACTIVA EN BASE A LA FECHA ACTUAL */
  _getTarifaActual(expo) {
    const fecha = moment(new Date(), "YYYY-MM-DD HH:mm:ss");
    const tarifa = expo.expo_date_inscription.filter(x => {
      const ini = moment(x.ini_date, "YYYY-MM-DD HH:mm:ss");
      const fin = moment(x.end_date, "YYYY-MM-DD HH:mm:ss");
      if (fecha.isBetween(ini, fin, "[]")) {
        return x;
      }
    });
    //console.log("tarifa actual", tarifa)
    return tarifa[0];
  }
  /* FUNC PARA GENERAR UNA LISTA CON LOS PERROS DEL USUARIO ELIGIBLES DEPENDIENDO DE LA TARIFA ACTUAL  */
  _currentLocalDogsUserTarifaActual() {
    const userDogs = this.userData.dogs;
    let tmp = [];

    for (let i = 0; i < userDogs.length; i++) {
      const dog = userDogs[i];
      //COMPROBAMOS QUE LA EXPO ADMITA LA RAZAS O NO
      if (!this._checkDogBreed(dog.breeds.id)) {
        continue;
      }
      const expoFechas = this.expoData.expo_date.map(x => x.ini_date);
      //GENERAMOS UN ARRAY DE LAS CLASES A LA QUE PUEDE ACCEDER
      const edadEnMeses = this._calculateRelativeAge(dog.birth, expoFechas[0]);
      //const clasesAdmitidas = this._getEligibleClasses(edadEnMeses);
      const clasesAdmitidas = this._getEligibleClassesTarifaActual(edadEnMeses);
      // si no hay razas admitidas continuamos en la siguiente iteración
      if (clasesAdmitidas.length === 0) {
        this._debug(["no admitido por clase", dog.name, edadEnMeses])
        continue;
      }
      //comprobamos si la clase del perro está admitido en la tarifa
      const admitidoRazaTarifa = this._checkDogAdmitidoClaseRaza(clasesAdmitidas, dog);
      if (admitidoRazaTarifa === false) {
        this._debug(["no admitido por raza/tarifa", dog.name]);
        continue;
      }
      //NOTA: comprobamos si la nacionalidad del usuario es admitida en la tarifa

      //comprobamos si el perro necesita documentos que no están subidos
      //NOTA: se debe compatibilizar los documentos subidos para en los datos del perro con los de la expo
      const docsPendientes = this._checkDocsDataRequired(dog);
      const copropietarios = this._getDogCoOwners(dog.id);

      //FINALMENTE CREAMOS UN OBJ QUE AÑADIMOS AL ARRAY
      let row = {
        id: dog.id,
        name: dog.name,
        birth: dog.birth,
        chip: dog.chip,
        breed_id: dog.breeds.id,
        breed_name: dog.breeds.translations[0].name,
        breed_variety: dog.breeds.translations[0].variety,
        breed_subvariety: dog.breeds.translations[0].subvariety,
        class_selected: null,
        coPropietarios: copropietarios,
        expo_fechas: expoFechas,
        edad: edadEnMeses,
        clases: clasesAdmitidas,
        docsDatos: docsPendientes
      };
      //Agregamos al array      
      tmp.push(row);

    }

    this.contador.fin = Date.now();
    return tmp;

  }
  /* FUNCION PARA COMPROBAR SI EL PERRO REQUIERE DOCUMENTOS */
  _checkDocsDataRequired(dog) {
    //this.expoData.expo_documents_required   
    const docs = this.expoData.expo_documents_required.filter(x => {
      if (x.need_document === 1) return x;
    });
    const datos = this.expoData.expo_documents_required.filter(x => {
      if (x.need_document === 0) return x;
    });
    if (dog.files.length > 0)
      this._debug([docs, datos, dog])

    return {
      docs,
      datos,
      book: dog.dog_book_id
    }
  }
  /*  FUNCION PARA COMPROBAR SI LA RAZA SE ADMITE O NO EN LA EXPO */
  _checkDogBreed(breedId) {
    const expoAllBreeds = this.expoData.all_breeds;
    if (expoAllBreeds === 1) {
      return true;
    }
    let dogBreeds = this.expoData.expo_breeds.split(",");
    return dogBreeds
      .map(item => (parseInt(item) ? parseInt(item) : item))
      .includes(breedId);
  }
  /* calcular la edad relativa del perro con respecto a la expo - EN MESES */
  _calculateRelativeAge(dateBirth, dateExpo) {
    let a = moment(dateBirth, "DD/MM/YYYY");
    let b = moment(dateExpo, "YYYY-MM-DD");
    let meses = b.diff(a, "months", true); //true para que no se trunquen los decimales
    let dias = b.diff(a, "days");
    return meses.toFixed(3);
    //return moment(dateBirth, "DD/MM/YYYY").from(dateExpo, "YYYY-MM-DD");
  }
  /* CALCULAR LA LISTA DE CLASES EN LA QUE SE LES PUEDE INSCRIBIR AL PERRETE DEPENDIENDO DE LA TARIFA ACTUAL ....*/
  _getEligibleClassesTarifaActual(dogAge) {
    //generamos la lista de perros
    const tmpClasses = this.expoData.expo_dog_classes;
  //  console.log(tmpClasses)
    let dogClasses = [];

    this.tarifaActual.expo_rate_types.forEach(e => {
    //  console.log(e)
      if (e.classes_id !== null) {

        e.classes_id.split(",").forEach(x => {
          const filtro = tmpClasses.filter(a => {
           // if (parseInt(a.id) === parseInt(x)) return a;
           //modificado 10-03-2020 control al campo de la clase padre
            if (parseInt(a.dog_class_id) === parseInt(x)) return a;
          });
          const tmp = dogClasses.filter(a => {
            if (parseInt(a.id) === parseInt(x)) return a;
          });
          //las clases que no tengamos ya en el array dogClass las insertamos
          if (tmp.length === 0) {
            dogClasses.push(filtro[0]);
          }
        });
      }
    });

    const clases = dogClasses.filter(a => {
      const min_age = parseFloat(a.min_age);
      const max_age = parseFloat(a.max_age);
      if (
        parseFloat(dogAge) >= min_age &&
        parseFloat(dogAge) <= max_age &&
        min_age !== 0 &&
        max_age !== 0
      ) {
        return a;
      }
    }).map(x => {
      return {
        id: x.id,
        class: x.class
      };
    });

    return clases;
  }
  /* FUNCION PARA COMPROBAR SI EL PERRO EN CUESTION ESTÁ ADMITIDO EN algunas de las TARIFAS POR RAZA */
  _checkDogAdmitidoClaseRaza(clasesAdmitidas, dog) {
    const tarif = this.tarifaActual.expo_rate_types;
    const clases = clasesAdmitidas.map(x => x.id);
    let admitido = [];

    for (let i = 0; i < tarif.length; i++) {
      const x = tarif[i];
      let eligibleClase = false;
      let eligibleRaza = false;

      if (x.classes_id !== null) {
        const salida = this._existeInArray(x.classes_id.split(','), clases);
        eligibleClase = salida === true ? true : false;
      } else {
        eligibleClase = true;
      }

      if (x.breeds_id !== null) {
        eligibleRaza = !!x.breeds_id.split(',').includes(dog.dog_breed_id);
      } else {
        eligibleRaza = true;
      }
      //si es eligible en clase y raza lo agregamos como admitido
      if (eligibleClase === true && eligibleRaza === true) {
        admitido.push(x.id);
      }
    }
    return (admitido.length > 0) ? true : false;
  }
  /* FUNC PARA USO INTERNO DE _checkDogAdmitidoClaseRaza para comparar datos en dos arrays */
  _existeInArray(ar1, ar2) {
    // console.log("_existeInArray", ar1, ar2);
    for (let i = 0; i < ar1.length; i++) {
      let el1 = parseInt(ar1[i]);
      for (let j = 0; j < ar2.length; j++) {
        let el2 = parseInt(ar2[j]);
        if (el1 === el2) {
          return true;
        }
      }
    }
    return false;
  }
  /* funcion para recoger los datos de los copropietarios */
  _getDogCoOwners(dogId) {
    return this.userData.dogs.filter((x) => x.id == dogId)[0].cowners;
  }

  /* 
 ======================================================================
  #endregion PARA CREAR LAS TARIFAS ELIGIBLES DE CADA PERRO DEL USUARIO
  #endregion
  =====================================================================
  */

  /* 
  ================================================================
  #region VARIOS 
  ================================================================
  */

  /* DEBUG PARA MOSTRAR POR CONSOLA DATOS QUE ME INTERESEN */
  _debug(datos) {
    if (this.debug === true) {
      console.log(datos);
    }
  }
  /* DEVUELVE EL TIEMPO QUE HA TARDADO EN GENERARSE LOS DATOS */
  getTiempo() {
    return (this.contador.fin - this.contador.inicio);
  }
  /* FUNCION PARA NORMALIZAR LOS DATOS DE LAS INSCRIPCIONES A UN OBJ */
  _normalizarData() {

    return new Promise((resolve, reject) => {

      this.tarifaNormalizada = [];

      if (this.inscripciones === null) {
        return null;
      }

      for (let i = 0; i < this.inscripciones.length; i++) {
        const element = this.inscripciones[i];
        const tarifaId = element.tarifaId;

        element.dogs.forEach(e => {
          let row = {
            dogId: e.id,
            tarifaId: tarifaId,
            clase: e.clase,
            precio: (this.socio === 1) ? e.precio.price_partner : e.precio.price,
            filtrosAplicados: e.filtrosAplicados,
            descuentos: 0,
            grupoPrecio: e.grupoPrecio,
            posicion: e.posicion,
            precioAplicado: e.precioAplicado,
            hayCopropietarios: e.hayCopropietarios
          }

          this.tarifaNormalizada.push(row);

        });

      }

      return resolve(this.tarifaNormalizada);
    });
  }
  /* PRUEBAS: FUNCION PARA GENERAR UN TEXTO DEL IMPORTE TOTAL DE LOS PERROS INSCRITOS */
  calcularImporteTotal(mostrarSocios = false, mostrarTodos = true) {
    let tmpTarifa = this.inscripciones;

    if (tmpTarifa !== null && tmpTarifa.length > 0) {
      let totalNoSocio = 0;
      let totalSocio = 0;
      for (let i = 0; i < tmpTarifa.length; i++) {
        const element = tmpTarifa[i].dogs;

        const importeTmp = element
          .map(x => x.precio.price)
          .reduce((a, x) => (a += x));
        totalNoSocio += importeTmp;

        const importeTmp2 = element
          .map(x => x.precio.price_partner)
          .reduce((a, x) => (a += x));
        totalSocio += importeTmp2;
      }
      let texto = "";
      if (mostrarTodos === true) {
        texto = "Socios: " + totalSocio + " €, No Socios: " + totalNoSocio + " €"
      } else if (mostrarSocios === true) {
        texto = "Socios: " + totalSocio + " €";
      } else {
        texto = " No Socios: " + totalNoSocio + " €";
      }
      return texto;
    }
  }

  /* 
    #endregion REGION VARIOS 
  */

}